import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsoleEntry } from './console.entry';

export const SOFTLINE_SETTINGS_CONSOLE = 'console';
export const SOFTLINE_DATA_CONSOLE = new InjectionToken<
  Observable<ConsoleEntry[]>
>('SOFTLINE_DATA_CONSOLE');
